import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=5fe73baf&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=5fe73baf&prod&lang=scss&scoped=true&"
import style1 from "./SideMenu.vue?vue&type=style&index=1&id=5fe73baf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe73baf",
  null
  
)

export default component.exports